import { createQueryHook } from '~/shared/providers/api';

export interface CpUserRoleAssignmentsQueryParams {
  userId: string;
}

export interface CpUserRoleAssignment {
  id: string;
  roleId: string;
  facilityId: string;
}

export interface CpUserRoleAssignmentsQueryResult {
  assignments: CpUserRoleAssignment[];
}

export const useCustomerPortalUserRoleAssignmentsQuery = createQueryHook(
  'settings.customerPortal.userRoleAssignments',
  (params: CpUserRoleAssignmentsQueryParams) => ({
    coreUserRoleAssignments: {
      __args: {
        filter: {
          userId: params.userId,
          pagination: {
            limit: 10000,
            offset: 0,
          },
        },
      },
      entries: {
        id: true,
        role: {
          id: true,
        },
        facility: {
          id: true,
        },
      },
    },
  }),
  {
    select: (data): CpUserRoleAssignmentsQueryResult => ({
      assignments:
        data?.coreUserRoleAssignments?.entries?.map((entry) => ({
          id: entry.id,
          roleId: entry.role?.id ?? '',
          facilityId: entry.facility?.id ?? '',
        })) ?? [],
    }),
  },
);
